import { MatSpinner } from '@angular/material/progress-spinner';
import { HttpClient } from '@angular/common/http';
import { Component, inject, Signal, signal, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';
import { SearchBarComponent } from '../../shared/components/search-bar-component/search-bar-component';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe } from '@angular/common';
import { Assurance, Collaborateur } from '../../shared/model';
import { MatRippleModule } from '@angular/material/core';
import { HomeService } from '../services/home-service';
import { ChartData, ChartOptions } from 'chart.js';
import { AuthService } from '../../auth/services/auth-service';
import { AuthUser } from '../../auth/models/auth';

interface DasboardI{
  id : string,
  title : string,
  img : string,
  description : string,
  compteur ?: number,
  right : string,
  path : string
}

@Component({
  selector: 'app-home-component',
  imports: [
    MatCardModule,
    MatIconModule,
    BaseChartDirective,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSpinner,
    MatRippleModule,
    MatTooltip
  ],
  templateUrl: './home-component.html',
  styleUrl: './home-component.css',
})
export class HomeComponent {

  displayedColumns: string[] = ['rang', 'nb', 'site', 'groupe'];
  displayedColumnsAss: string[] = ['police', 'attestation', 'carte_rose', 'compagnie_name', 'assure', 'vehicule'];
  dataSource!: MatTableDataSource<Collaborateur>;
  dataSourceAss!: MatTableDataSource<Assurance>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('paginatorAss') paginatorAss!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  searchValue = signal<string>('')

  currentUser : AuthUser = inject(AuthService).getCurrentUser()

  loading = signal<boolean>(false)

  dashboard : DasboardI[]=[
    {
      id : 'collaborateurs',
      title : "Collaborateurs",
      description : 'Liste des Collaborateurs',
      path : 'collaborateurs',
      right : 'collaborateurs',
      img : '/avatar/collaborateur.png',
      compteur : 0
    },
    {
      id : 'bureaux',
      title : "Bureaux",
      description : 'Liste des bureaux',
      path : 'bureaux',
      right : 'sites',
      img : '/avatar/bureau.jpg',
      compteur : 0
    },
    {
      id : 'users',
      title : "Utilisateurs",
      description : 'Liste des utilisateurs',
      path : 'users',
      right : 'users',
      compteur : 0,
      img : '/avatar/users.jpg'
    },
    {
      id : '',
      title : "Nouvelle Affaire",
      description : 'Etablir une assurance',
      path : 'assure',
      right : 'assurances',
      img : '/avatar/affaire.png'
    },
    {
      id : '',
      title : "Avenant",
      description : 'Effectuer un avenant',
      path : 'avenant',
      right : 'assurances',
      img : '/avatar/avenant.png'
    },
    {
      id : 'doc_servis',
      title : "Production(s)",
      description : "Assurance servis au cour de l'annee",
      path : `document_details/servis`,
      right : 'assurances',
      img : '/avatar/doc_servis.png',
      compteur : 0
    },
    {
      id : 'doc_annule',
      title : "Assur. annules",
      description : "Assurance annules au cour de l'annee",
      path : `document_details/annule`,
      right : 'assurances',
      img : '/avatar/doc_annule.png',
      compteur : 0
    },
    {
      id : 'rapport_suivi',
      title : "Rapport suivi",
      description : "Envoyer un rapport de transmission",
      path : `rapport_suivi`,
      right : 'rapport_suivi',
      img : '/avatar/rapport_suivi.png',
      compteur : 0
    },
    {
      id : 'validation_suivi',
      title : "Validation rapport suivi de groupe",
      description : "Valider les rapport de suivi d'un groupe",
      path : `suivi/validation`,
      right : 'validation_suivi',
      img : '/avatar/suivi_valide.png',
      compteur : 0
    },
    {
      id : 'reception_suivi',
      title : "Reception rapport suivi",
      description : "Valider un rapport de transmission",
      path : `suivi/reception`,
      right : 'reception_suivi',
      img : '/avatar/reception_suivi.png',
      compteur : 0
    },
    {
      id : 'renvoi_suivi', 
      title : "Renvoi en compagnie",
      description : "Renvoi des documents en compagnie",
      path : `renvoi_compagnie`,
      right : 'renvoi_suivi', // 'renvoi_compagnie'
      img : '/avatar/renvoi.png',
      compteur : 0
    },
    {
      id : 'stock_sites',
      title : "Gestion du stocks",
      description : 'Gestion du stocks des bureaux',
      path : 'stock_sites',
      right : 'stock_sites',
      img : '/avatar/stock.png'
    },
    {
      id : '',
      title : "Statistiques",
      description : 'Details des stats sur une periode',
      path : '#',
      right : 'owner',
      img : '/avatar/stat.png'
    }
  ]

  cpt : number = 0

  DayOfWeek = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']

  currentDay = new Intl.DateTimeFormat('fr-FR', { weekday: 'long' }).format(new Date());


  chartData !: ChartData<'bar'>
// </block:setup>

  chartOptions : ChartOptions = {
    responsive : true,
    scales: {
      y: {
        beginAtZero: true,
        min : 0,
        max : 50,
        ticks : {
          stepSize : 5
        },
        title :{
          display : true,
          text : 'Assurances servis'
        }
      },
      x : {
        title : {
          display : true,
          text : 'periode'
        }
      }
    }
  }
  isDataLoaded = signal<boolean>(true)

  backgroundColor = [
        'rgba(255, 99, 132, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgba(255, 205, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(201, 203, 207, 0.2)'
  ]

  borderColor = [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
      ]

  constructor
  (
    private router : Router,
    private homeService : HomeService
  ){

  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<any>([]);
    this.dataSourceAss = new MatTableDataSource<any>([]);

    this.loading.update(val => true)
    this.isDataLoaded.update(val => false)

    this.homeService.dashboard().subscribe((res) =>{
      console.log(res);

      this.dashboard.forEach(item =>{
        if(item.id!='')
          item.compteur = res.compteur[item.id]
          this.dataSource.data = res.classement
          this.dataSourceAss.data = res.production
      })
      //

      this.loadChart(res.graph)
      res.graph.forEach(item => this.cpt += item.count)
      this.isDataLoaded.update(val => true)
      this.loading.update(val => false)
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort
    this.dataSourceAss.paginator = this.paginatorAss;
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getRank(row : Collaborateur){
    return this.dataSource.data.indexOf(row)+1
  }

  loadChart(data : [{jour_semaine : string, count : number}]){
    const dataGraph : number[] = []
    this.DayOfWeek.forEach(day => {
      const elt = data.findIndex(item => item.jour_semaine == day)
        if(elt != -1)
          dataGraph.push(data[elt].count)
        else
          dataGraph.push(0)
    })


   this.chartData = {
    labels: this.DayOfWeek,
    datasets: [{
      type : 'bar',
      label: 'Assurances servis ',
      data: dataGraph,
      backgroundColor: this.backgroundColor,
      borderColor:this.borderColor,
      borderWidth: 1
    }]
   }
  }

  currentColor(tableau : string[]) : string[]{

  const indexDestination = 0
  const indexOrigine = this.DayOfWeek.findIndex(item => item.toLowerCase() == this.currentDay.toLowerCase())
  // 1. Supprime l'élément et le récupère
  const [element] = tableau.splice(indexOrigine, 1);

  // 2. Réinsère l'élément à la nouvelle position
  tableau.splice(indexDestination, 0, element);

  return tableau;
}

  goTo(path : string){
    this.router.navigateByUrl('/'+path)
  }
}
